import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";
import amber from "@material-ui/core/colors/amber";
import grey from "@material-ui/core/colors/grey";
import blue from "@material-ui/core/colors/blue";
import { blueGrey, green } from "@material-ui/core/colors";

export const THEME = responsiveFontSizes(
  createMuiTheme({
    breakpoints: {
      values: {
        lg: 1280,
        md: 960,
        sm: 600,
        xl: 1560,
        xs: 0,
      },
    },
    palette: {
      primary: {
        dark: blue[700],
        main: "#0081c6",
        light: blue[200],
      },
      secondary: {
        main: green[500],
        light: green[400],
        dark: green[600],
      },
      background: {
        default: "#fff",
      },
      text: {
        primary: blueGrey[900],
        secondary: blueGrey[600],
      },
    },
    typography: {
      h1: {
        fontSize: "2.2rem",
      },
      h2: {
        fontSize: "2rem",
      },
      h3: {
        fontSize: "1.8rem",
      },
      h4: {
        fontSize: "1.6rem",
      },
      h5: {
        fontSize: "1.4rem",
      },
      h6: {
        fontSize: "1.2rem",
      },
    },
    overrides: {
      MuiDialog: {
        root: {
          // zIndex: "1000 !important",
        },
      },
      MuiTab: {
        root: {
          fontSize: 16,
          fontWeight: 600,
          letterSpacing: 1,
        },
        textColorPrimary: {
          color: "#18202e",
        },
      },
    },
    props: {
      MuiButton: {
        disableFocusRipple: true,
      },
      MuiTab: {
        disableFocusRipple: true,
      },
      MuiIconButton: {
        disableFocusRipple: true,
      },
      MuiDialog: {
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
      },
    },
  })
);
